// Formatting helpers. Currency is SGD. No em dashes anywhere in copy.
export const EMPTY_MARK = "\u00B7"; // middle dot, used where a value is absent

export const CURRENCY_SYMBOLS = { SGD: "S$", USD: "US$", AUD: "A$" };

export function moneyCompact(n, currency = "SGD") {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  const sym = CURRENCY_SYMBOLS[currency] || `${currency} `;
  const abs = Math.abs(n);
  if (abs >= 1_000_000) {
    const v = n / 1_000_000;
    return `${sym}${(Math.abs(v) >= 100 ? v.toFixed(0) : v.toFixed(2))}M`;
  }
  if (abs >= 1_000) {
    const v = n / 1_000;
    return `${sym}${(Math.abs(v) >= 100 ? v.toFixed(0) : v.toFixed(1))}k`;
  }
  return `${sym}${Number(n).toLocaleString()}`;
}

export function moneyFull(n, currency = "SGD") {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  const sym = CURRENCY_SYMBOLS[currency] || `${currency} `;
  return `${sym}${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function pct(n, digits = 1) {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  return `${Number(n).toFixed(digits)}%`;
}

export function shortDate(iso) {
  if (!iso) return EMPTY_MARK;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return EMPTY_MARK;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function shortDay(iso) {
  if (!iso) return EMPTY_MARK;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return EMPTY_MARK;
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

export function relativeTime(iso) {
  if (!iso) return EMPTY_MARK;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return EMPTY_MARK;
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return shortDay(iso);
}

export function dueLabel(iso) {
  if (!iso) return EMPTY_MARK;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return EMPTY_MARK;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(d);
  target.setHours(0, 0, 0, 0);
  const days = Math.round((target - today) / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  if (days < 0) return `${Math.abs(days)}d overdue`;
  return `In ${days}d`;
}

// Mission Control helpers ----------------------------------------------------
export function monthLabel(ym) {
  if (!ym) return EMPTY_MARK;
  const [y, m] = String(ym).split("-").map(Number);
  if (!y || !m) return ym;
  const d = new Date(Date.UTC(y, m - 1, 1));
  return d.toLocaleDateString("en-GB", { month: "short", year: "numeric" });
}

export function monthShort(ym) {
  if (!ym) return EMPTY_MARK;
  const [y, m] = String(ym).split("-").map(Number);
  if (!y || !m) return ym;
  const d = new Date(Date.UTC(y, m - 1, 1));
  return d.toLocaleDateString("en-GB", { month: "short" });
}

export function num(n) {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  return Number(n).toLocaleString();
}

export function ratioLabel(n) {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  return `${Number(n).toFixed(1)}:1`;
}

export function months(n, digits = 1) {
  if (n === null || n === undefined || isNaN(n)) return EMPTY_MARK;
  return `${Number(n).toFixed(digits)} mo`;
}
